import { UnreachableFunction } from 'ui/base/types';
import { Payment, PaymentType } from '../../types';
import Messages from './payments_messages';

export function getPaymentMethodName(payment: Payment) {
  switch (payment.type) {
    case PaymentType.STRIPE:
      return payment.name;
    default:
      return UnreachableFunction(payment.type);
  }
}

export function getPaymentMethodInfo(payment: Payment) {
  switch (payment.type) {
    case PaymentType.STRIPE:
      return payment.label;
    default:
      return UnreachableFunction(payment.type);
  }
}

export function getPaymentMethodPlatform(payment: Payment) {
  switch (payment.type) {
    case PaymentType.STRIPE:
      return Messages.platformStripe();
    default:
      return UnreachableFunction(payment.type);
  }
}
